/**
 * Adres defteri + Wake-on-LAN — localStorage'da saklanır (tarayıcı-lokal,
 * kullanıcı hesabı-aware). Window controller'daki SavedHost mirror.
 */
const KEY_PREFIX = 'photon.addressBook.';
function key(userEmail) {
    return KEY_PREFIX + (userEmail ?? 'anon');
}
export function loadSavedHosts(userEmail) {
    try {
        const raw = localStorage.getItem(key(userEmail));
        if (!raw)
            return [];
        const list = JSON.parse(raw);
        return Array.isArray(list) ? list : [];
    }
    catch {
        return [];
    }
}
export function saveSavedHosts(userEmail, list) {
    localStorage.setItem(key(userEmail), JSON.stringify(list));
}
export function upsertHost(userEmail, host) {
    const list = loadSavedHosts(userEmail);
    const idx = list.findIndex(h => h.id === host.id);
    if (idx >= 0)
        list[idx] = host;
    else
        list.unshift(host);
    saveSavedHosts(userEmail, list);
}
export function deleteHost(userEmail, id) {
    saveSavedHosts(userEmail, loadSavedHosts(userEmail).filter(h => h.id !== id));
}
export function touchLastUsed(userEmail, humanId) {
    const list = loadSavedHosts(userEmail);
    const h = list.find(x => x.humanId.replace(/\s+/g, '') === humanId.replace(/\s+/g, ''));
    if (h) {
        h.lastUsedAt = new Date().toISOString();
        saveSavedHosts(userEmail, list);
    }
}
/** MAC adres format validator. "AA:BB:CC:DD:EE:FF" veya "AA-BB-..." kabul. */
export function validateMac(mac) {
    return /^([0-9A-Fa-f]{2}[:\-]){5}[0-9A-Fa-f]{2}$/.test(mac.trim());
}
